import { lazyResetFromRefinerFlyout } from "../../lazyFunctions";

export const onFromRefinerClicked = (): void => {
    lazyResetFromRefinerFlyout.import().then(resetFromRefinerFlyout => {
        resetFromRefinerFlyout();
    });
};
